import React, { useState } from 'react';
import { H3 } from 'client/v3/typography';
import useUser from 'client/hooks/queries/useUser';
import InfoForm from './InfoForm';
import PaymentForm from './PaymentForm';
import Form from '@ff/ui/Form2';
import ButtonWithErrorBox from '@ff/ui/Form2/ButtonWithErrorBox';
import { initialValues as paymentInitialValues } from '@ff/ui/Form2/presets/PaymentForm';
import AuthForm from './AuthForm';
import Button from '@ff/ui/Button';
import useConfig from 'client/hooks/useConfig';
import ContainerWithPadding from '../ContainerWithPadding';
import ButtonContainer from './ButtonContainer';
import appHandlers from 'client/utils/appHandlers';

export default function AccountDetail(props) {
  const { dueAmount, onSaveClick, onUpdateClick, onPaymentClick, newOrder } = props;
  const needPayment = dueAmount > 0;

  const [isDoingPayment, setIsDoingPayment] = useState(false);
  const { WAITLIST } = useConfig();
  const [openPaymentForm, setOpenPaymentForm] = useState(false);

  const { APPONLY } = useConfig();
  const isApp = APPONLY === '1';

  const { user, loading: loadingUser } = useUser();

  if (loadingUser) return null;

  const initialValues = {
    // user info
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    zipCode: '',

    joinWaitlist: WAITLIST === '1',

    // billing
    ...paymentInitialValues,

    orderAgreement: false,
    referralCode: '',
    displayedReferralCode: '',
  };


  const handleSubmit = async (data, form) => {
    // need await to disable form while waiting for callback
    if (isDoingPayment) {
      await onPaymentClick(data, form);
    } else {
      if (newOrder) {
        await onSaveClick(data, form);
      } else {
        await onUpdateClick(data, form);
      }
    }
  }

  const handlePaymentButtonClick = () => {
    setOpenPaymentForm(true);
    setIsDoingPayment(true);
  }

  return (
    <>
      <ContainerWithPadding>
        {!isApp && <H3 marginBottom='30px'>Account Details:</H3>}
        {/* -------- for not logged in user -------- */}
        {
          !user && !isApp && <>
            <AuthForm />
            {/* fake disabled button */}
            <Button
              fullWidth
              variant='dark'
              disabled
              mt='20px'
              mb='32px'
            >
              Save My Design
            </Button>
          </>
        }
        {
          !user && isApp && <>
            <Button
              fullWidth
              variant='dark'
              mt='20px'
              mb='32px'
              onClick={() => {
                setTimeout(appHandlers.getHandlerByKey('Login'), 10);
              }}
            >
              Log In
            </Button>
          </>
        }
      </ContainerWithPadding>

      {/* -------- for logged in user -------- */}
      {
        user &&
        <>
          <Form formId='form' initialValues={initialValues} onSubmit={handleSubmit}>
            <ContainerWithPadding>
              {isApp && <H3>Account Details</H3>}
              <InfoForm />
              {/* {
              !newOrder && !needPayment && <JoinWaitlistCheckBox />
            } */}
            </ContainerWithPadding>
            {
              !openPaymentForm && (
                <ButtonContainer>
                  {
                    newOrder && !isDoingPayment &&
                    <ButtonWithErrorBox
                      flex='1'
                      width='unset'
                      name='saveConfiguration'
                      variant='dark'
                    >
                      Save My Design
                    </ButtonWithErrorBox>
                  }
                  {
                    !newOrder && !needPayment &&
                    <>
                      <ButtonWithErrorBox
                        flex='1'
                        width='unset'
                        name='updateOrder'
                        variant='dark'
                      >
                        Update Preorder
                      </ButtonWithErrorBox>
                    </>
                  }
                  {
                    needPayment && !openPaymentForm && (
                      <Button
                        flex='1'
                        variant='dark'
                        width='unset'
                        onClick={handlePaymentButtonClick}
                      >
                        {newOrder ? 'Preorder' : 'Payment'}
                      </Button>
                    )

                  }
                </ButtonContainer>)
            }
            {
              openPaymentForm && (
                <PaymentForm dueAmount={dueAmount} newOrder={newOrder} />
              )
            }
          </Form>
        </>
      }
    </>
  );
}
